/**
 * Paleta kolorów ikon menu customowych (Kreator menu) — ZAMKNIĘTA, w barwach logo Workflow365.
 * Klucze pochodzą z `MENU_COLORS` (packages/shared) i są zapisywane w bazie; tu jest tylko
 * mapowanie na barwę. Kolejność = kolejność cyklu kolorów kafelków w pasku bocznym (fallback dla
 * menu bez wybranego koloru), więc `MENU_COLOR_RGB[i]` = i-ty kolor cyklu.
 */

import { MENU_COLORS, type MenuColor } from '@saas/shared';

export { MENU_COLORS, type MenuColor };

/** Barwa w formacie „R G B" (spacja) — wprost pod zmienną CSS `--c` kafelka `.rail-glass`. */
export const MENU_COLOR_RGB: Record<MenuColor, string> = {
  blue: '31 111 214',
  green: '63 185 80',
  orange: '242 106 27',
  violet: '124 92 255',
  teal: '14 165 183',
  pink: '236 72 153',
  amber: '234 179 8',
};

/** Ta sama barwa jako hex/rgb do zwykłych stylów (próbnik, podgląd, ikona na liście). */
export function menuColorCss(color: MenuColor): string {
  return `rgb(${MENU_COLOR_RGB[color].split(' ').join(', ')})`;
}

/** Bezpieczny odczyt klucza z danych z API (nieznana wartość → null = kolor domyślny). */
export function parseMenuColor(value: string | null | undefined): MenuColor | null {
  return (MENU_COLORS as readonly string[]).includes(value ?? '') ? (value as MenuColor) : null;
}
